<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="display-1">O nas</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>

</style>
